import { formURL } from "Utils/CommonUtilities";
import BaseApiRequest from "./BaseApiRequest";
import { GET_BUNDLE_PRODUCT_RELATION_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class GetBundleProductRelation extends BaseApiRequest {
  method = METHOD.HTTP.GET;

  body = {};

  url = GET_BUNDLE_PRODUCT_RELATION_URL;

  constructor(requestData) {
    super();
    const paramList = [requestData.bundleProductId];
    this.url = formURL(this.url, paramList);
  }

  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(this.url);

  getBody = () => this.body;
}
